import React, { PropsWithChildren, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";

function createWrapperAndAppendToBody(wrapperId: string): HTMLDivElement {
  const wrapperElement = document.createElement("div");
  wrapperElement?.setAttribute("id", wrapperId);
  document.body.appendChild(wrapperElement);

  return wrapperElement;
}

interface Props {
  wrapperId?: string;
}

const ReactPortal = ({
  children,
  wrapperId = "",
}: PropsWithChildren<Props>): React.ReactPortal | null => {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(
    null,
  );

  useLayoutEffect(() => {
    // See if the element that the user wants to use as the anchor for the portal exists.
    // If it does not, then make it.
    let createdWrapper = false;
    let element = document.getElementById(wrapperId);
    if (!element) {
      element = createWrapperAndAppendToBody(wrapperId);
      createdWrapper = true;
    }
    setWrapperElement(element);

    return () => {
      if (createdWrapper && element?.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);

  // wrapperElement state will be null on the very first render.
  if (wrapperElement === null) return null;

  return createPortal(children, wrapperElement);
};

export default ReactPortal;
